import type {
  GetCustomerAccountAddressesResponse,
  GetCustomerAccountResponse,
} from '@djust-b2b/djust-front-sdk';
import type { CustomerUser } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/customer-user.js';
import { defineStore } from 'pinia';

interface State {
  isAuthenticated: boolean;
  user: null | undefined | CustomerUser;
  account: null | GetCustomerAccountResponse | BasicAccount;
  accounts: null | BasicAccount[];
  shippingAddresses: GetCustomerAccountAddressesResponse;
  billingAddresses: GetCustomerAccountAddressesResponse;
  currency: null | string;
}

type BasicAccount = Pick<GetCustomerAccountResponse, 'id' | 'name' | 'externalId'>;

export const useUserStore = defineStore('user', {
  state: (): State => ({
    isAuthenticated: false,
    user: null,
    account: null,
    accounts: null,
    shippingAddresses: [],
    billingAddresses: [],
    currency: null as null | string,
  }),

  actions: {
    loginAuthenticatedUser(authenticatedUser: {
      user: CustomerUser;
      accounts: BasicAccount[];
      account: BasicAccount;
      currency: string;
    }) {
      this.isAuthenticated = true;
      this.user = authenticatedUser.user;
      this.account = authenticatedUser.account;
      this.accounts = authenticatedUser.accounts;
      this.currency = authenticatedUser.currency;
      const customerAccountIdCookie = useCookie('customer-account-id');
      //customerAccountIdCookie.value = this.account?.id;
    },
    setAccount(account: GetCustomerAccountResponse) {
      this.account = account;
    },
    login(authenticatedUser: {
      user: CustomerUser;
      accounts: BasicAccount[];
      account: GetCustomerAccountResponse;
      currency: string;
    }) {
      this.loginAuthenticatedUser(authenticatedUser);
      this.setAccount(authenticatedUser.account);
    },
    logout() {
      this.isAuthenticated = false;
      this.user = null;
      this.account = null;
      this.accounts = null;
      this.shippingAddresses = [];
      this.billingAddresses = [];
      this.currency = null;
    },
  },
});
